export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/more-icon.svg?8d6baef8ffbb2a52fbd89039a9b2e8ab";